export default __webpack_public_path__ + "static/media/bb.b0e17174.svg";